import styled from 'styled-components';

export const AnalyticsChart = styled.div`
  .analytics-chart {
    width: 100% !important;
    max-width: 100%;
    height: 640px !important;
  }
`;
